import React from 'react';
import { Link } from 'react-router-dom';
import SnowBackground from './SnowBackground';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <SnowBackground />
      
      <div className="nf-content">
        <h1 className="glitch" data-text="404">404</h1>
        <h2>LOST IN THE VOID</h2>
        <p>The page you are looking for has consumed itself.</p>
        
        <Link to="/" className="btn">
          RETURN TO BASE
        </Link>
      </div>
    </div>
  );
};

export default NotFound;